import { render } from "./FooterAdmin.vue?vue&type=template&id=549f1e4c"
import script from "./FooterAdmin.vue?vue&type=script&lang=js"
export * from "./FooterAdmin.vue?vue&type=script&lang=js"
script.render = render

export default script